import React, { useEffect, useState, useRef } from "react";
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Collapse from 'react-bootstrap/Collapse';
import Card from 'react-bootstrap/Card';
import ListGroup from 'react-bootstrap/ListGroup';

import dglogo from '../assets/img/logo-dark.svg'

import Form from 'react-bootstrap/Form';


import * as AWS from 'aws-sdk';
import { configData } from "../config/systemconfigurationconstants";
import { Buffer } from "buffer";
import { Fragment } from 'react';
import { TiInputChecked } from "react-icons/ti";
import { useEncryption } from '../customHooks/useEncryption';
// import '../../src/assets/css/loan-import.css'; 
const GlassBox = () => {
   const { encrypt, decrypt } = useEncryption();
   const getCookie = (name) => {
      const value = `; ${document.cookie}`;
      const parts = value.split(`; ${name}=`);
      if (parts.length === 2) {
         return decodeURIComponent(parts.pop().split(';').shift());
      }
      return null;
   };
   let glassboxjson = JSON.parse(localStorage.getItem('glassboxjson'));
   let clickedRule = JSON.parse(localStorage.getItem('clickedRule'));
   let categoryID = localStorage.getItem('categoryID');
   const [groupedTabData, setGroupedTabData] = useState();
   const [status, setStatus] = useState("");
   const [glassBoxConditionData, setGlassBoxConditionData] = useState(glassboxjson.ConditionDetails)
   const [storeClikedRuleId, setStoreClikedRuleId] = useState()
   const [isSwitchOn, setIsSwitchOn] = useState(false);
   const [hideLID, setHideLID] = useState(true);
   const [isOverflowing, setIsOverflowing] = useState(false);
   const [showFullText, setShowFullText] = useState(false);
   const textRef = useRef(null);
   const handleSwitchChange = () => {
      const newSwitchState = !isSwitchOn;
      setIsSwitchOn(newSwitchState);
      filterDataByStatus(status, newSwitchState); // ✅ use the updated value
   };
   useEffect(() => {
      if (clickedRule.RRSV === "Override") {
         filterDataByStatus("Open", isSwitchOn);
         setStatus("Open")
      } else if (clickedRule.RRSV !== "Override") {
         filterDataByStatus("Passed", isSwitchOn);
         setStatus("Passed")
      }
      // console.log(glass, localStorage.getItem('categoryID'), JSON.parse(localStorage.getItem('clickedRule')))
   }, [])
   //new code 
   const filterDataByStatus = (val, switchState) => {
      let filteredData;

      const applyVerbiageFilter = (condition, verbiageFilterFn) => {
         let filteredVerbiage = condition?.Verbiage?.filter(verbiageFilterFn);

         // Apply IP filter if switch is ON
         if (switchState) {
            filteredVerbiage = filteredVerbiage?.filter(v =>
               v?.FieldInfo?.some(f => f?.IP)
            );
         }

         if (filteredVerbiage?.length > 0) {
            return {
               ...condition,
               Verbiage: filteredVerbiage
            };
         }
         return null;
      };

      if (val === "Open") {
         filteredData = {
            ConditionDetails: glassBoxConditionData
               .map(condition => applyVerbiageFilter(condition, v => v.RRSV === "Override"))
               .filter(Boolean)
         };
      } else if (val === "Passed") {
         filteredData = {
            ConditionDetails: glassBoxConditionData
               .map(condition => applyVerbiageFilter(condition, v => v.RRSV !== "Override"))
               .filter(Boolean)
         };
      } else if (val === "All") {
         filteredData = {
            ConditionDetails: glassBoxConditionData
               .map(condition => applyVerbiageFilter(condition, () => true)) // Keep all verbiage
               .filter(Boolean)
         };
      }

      // Process and set data
      console.log(filteredData, "filterOpenCondition");
      const groupedData = groupFieldInfoByRN(filteredData.ConditionDetails);
      setGroupedTabData(groupedData);

      const getFiltereddatabasedonID = filterByErrsid(groupedData, clickedRule);
      getClickedField(getFiltereddatabasedonID[0]?.FieldInfo, getFiltereddatabasedonID[0]);
   };

   // without image filert
   // commenter today
   // const filterDataByStatus = (val) => {
   //    let filteredData;
   //    if (val === "Open") {
   //       filteredData = {
   //          ConditionDetails: glassBoxConditionData
   //             .map(condition => {
   //                const filteredVerbiage = condition?.Verbiage?.filter(v => v.RRSV === "Override");
   //                if (filteredVerbiage?.length > 0) {
   //                   return {
   //                      ...condition,
   //                      Verbiage: filteredVerbiage
   //                   };
   //                }
   //                return null;
   //             })
   //             .filter(Boolean) // Remove null entries
   //       };
   //    }
   //    else if (val === "Passed") {
   //       filteredData = {
   //          ConditionDetails: glassBoxConditionData
   //             .map(condition => {
   //                const filteredVerbiage = condition?.Verbiage?.filter(v => v.RRSV !== "Override");
   //                if (filteredVerbiage?.length > 0) {
   //                   return {
   //                      ...condition,
   //                      Verbiage: filteredVerbiage
   //                   };
   //                }
   //                return null;
   //             })
   //             .filter(Boolean) // Remove null entries
   //       };
   //    }
   //    else if (val === "All") {
   //       filteredData = {
   //          ConditionDetails: glassBoxConditionData
   //       }
   //    }
   //    console.log(filteredData, "filterOpenCondition")
   //    const groupedData = groupFieldInfoByRN(filteredData.ConditionDetails);
   //    setGroupedTabData(groupedData)
   //    console.log(groupedData);
   //    let getFiltereddatabasedonID = filterByErrsid(groupedData, clickedRule)
   //    console.log(getFiltereddatabasedonID[0]?.FieldInfo, getFiltereddatabasedonID[0])
   //    getClickedField(getFiltereddatabasedonID[0]?.FieldInfo, getFiltereddatabasedonID[0]);
   //    // setStoreClikedRuleId(clickedRule)
   // }
   // const filterDataByStatus = (val, showFiltered) => {
   //   let filteredData;
   //   const processVerbiage = (verbiageList, applyFieldInfoFilter) => {
   //     return verbiageList
   //       .filter(v => {
   //         if (val === "Open" && v.RRSV !== "Override") return false;
   //         if (val === "Passed" && v.RRSV === "Override") return false;
   //         return true;
   //       })
   //       .map(v => {
   //         if (applyFieldInfoFilter && v.FieldInfo) {
   //           const newFieldInfo = {};
   //           let hasValidIP = false;
   //           for (const key in v.FieldInfo) {
   //             const fieldList = v.FieldInfo[key];
   //             if (Array.isArray(fieldList)) {
   //               const filteredFields = fieldList.filter(item => item.IP !== null);
   //               if (filteredFields.length > 0) {
   //                 newFieldInfo[key] = filteredFields;
   //                 hasValidIP = true;
   //               }
   //             }
   //           }
   //           return hasValidIP ? { ...v, FieldInfo: newFieldInfo } : null;
   //         }
   //         if (applyFieldInfoFilter && v.FieldInfo === null) return null;
   //         return v;
   //       })
   //       .filter(Boolean);
   //   };
   //   filteredData = {
   //     ConditionDetails: glassBoxConditionData
   //       .map(condition => {
   //         const verbiage = processVerbiage(condition.Verbiage, showFiltered);
   //         if (verbiage.length > 0) {
   //           return { ...condition, Verbiage: verbiage };
   //         }
   //         return null;
   //       })
   //       .filter(Boolean) // Remove null entries
   //   };
   //   console.log(filteredData, "filterOpenCondition");
   //   const groupedData = groupFieldInfoByRN(filteredData.ConditionDetails);
   //   setGroupedTabData(groupedData);
   //   console.log(groupedData);
   //   let getFiltereddatabasedonID = filterByErrsid(groupedData, clickedRule);
   //   if (getFiltereddatabasedonID && getFiltereddatabasedonID.length > 0) {
   //     getClickedField(getFiltereddatabasedonID[0]?.FieldInfo, getFiltereddatabasedonID[0]);
   //   } else {
   //     console.warn("No data found for clickedRule:", clickedRule);
   //     getClickedField(null, null); // Or handle gracefully
   //   }
   //   // console.log(getFiltereddatabasedonID[0]?.FieldInfo, getFiltereddatabasedonID[0]);
   //   // getClickedField(getFiltereddatabasedonID[0]?.FieldInfo, getFiltereddatabasedonID[0]);
   // };
   // const filterByErrsid = (data, targetErrsid) => {
   //   const results = [];
   //   data.forEach(category => {
   //     category.Verbiage.forEach(item => {
   //       item.FieldInfo.forEach(rulenames => {
   //         if (rulenames.RN === targetErrsid.FieldInfo[0].RN) {
   //           results.push(item);
   //         }
   //       });
   //     });
   //   });
   //   return results;
   // };
   const filterByErrsid = (data, targetRuleName) => {
      const results = [];
      data.forEach(category => {
         category.Verbiage?.forEach(item => {
            const fieldInfo = item.FieldInfo;
            if (
               fieldInfo &&                         // FieldInfo must not be null
               typeof fieldInfo === 'object' &&     // FieldInfo must be an object
               fieldInfo.hasOwnProperty(targetRuleName.FieldInfo[0].RN) // Check if rule name exists as key
            ) {
               results.push(item);
            }
         });
      });
      return results;
   };
   const groupFieldInfoByRN = (conditionDetails) => {
      return conditionDetails.map(condition => {
         const updatedVerbiage = condition?.Verbiage?.map(verbiage => {
            if (!verbiage?.FieldInfo) return verbiage;
            const grouped = verbiage?.FieldInfo?.reduce((acc, field) => {
               const { RN, ...rest } = field;
               if (!acc[RN]) {
                  acc[RN] = [];
               }
               acc[RN].push(rest);
               return acc;
            }, {});
            return {
               ...verbiage,
               FieldInfo: grouped // <-- replaced here
            };
         });
         return {
            ...condition,
            Verbiage: updatedVerbiage
         };
      });
   };
   const [openCID, setOpenCID] = useState(Number(categoryID));
   const [glassboximgview, setGlassboxImgview] = useState(8);
   const [glassboxfieldsview, setGlassboxFieldsview] = useState(2);
   const [clickedConditionText, setClickedConditionText] = useState('')
   const [clickedFieldList, setClickedFieldList] = useState([]);
   const clickOnExpand = () => {
      setGlassboxImgview(10); // Changes glassboximgview to 5
      setGlassboxFieldsview(!glassboxfieldsview); // Toggles glassboxfieldsview between true and false
   }
   // State to track whether the sm-2 column is collapsed or not
   const [isCollapsed, setIsCollapsed] = useState(false);
   // Toggle the collapse state
   const toggleCollapse = () => {
      setIsCollapsed(!isCollapsed);
      setHideLID(!hideLID);
   }
   const handleToggle = (cid) => {
      // If the clicked card is already open, close it; otherwise, open the new card
      setOpenCID(prevCID => (prevCID === cid ? null : cid));
   };
   const [zoomedIn, setZoomedIn] = useState(false);
   const [currentPage, setCurrentPage] = useState(0);
   const [allImageUrls, setAllImageUrls] = useState([]);
   const [glassboxImage, setGlassboxImage] = useState([]);
   const IMAGES_PER_PAGE = zoomedIn ? 1 : 2;
   // const getClickedField = (field, verbiage) => {
   //   setClickedConditionText(verbiage.CDN)
   //   const dynamicKey = Object.keys(field)[0]; // Get the dynamic key
   //   const dataArray = field[dynamicKey];
   //   setClickedFieldList(dataArray);
   //   console.log(clickedFieldList)
   //   console.log(field, 'field')
   //   if (Array.isArray(dataArray)) {
   //     dataArray.forEach(item => {
   //       if (item.IP) {
   //         const generateurl = 'https://' + configData.BUCKET_NAME + '.s3.amazonaws.com/' + item.IP;
   //         getImageUrl(generateurl);
   //       }
   //     });
   //   }
   // }
   // const getClickedField = (field, verbiage) => {
   //   setStoreClikedRuleId(verbiage.ERRSID)
   //   console.log(field, verbiage);
   //   setClickedConditionText(verbiage.CDN);
   //   const dynamicKey = Object.keys(field)[0];
   //   const dataArray = field[dynamicKey];
   //   setClickedFieldList(dataArray);
   //   const imageUrls = [];
   //   if (Array.isArray(dataArray)) {
   //     dataArray.forEach(item => {
   //       if (item.IP) {
   //         const generateurl = 'https://' + configData.BUCKET_NAME + '.s3.amazonaws.com/' + item.IP;
   //         imageUrls.push(generateurl);
   //       }
   //     });
   //     Promise.all(imageUrls.map(getImageUrl)).then(signedUrls => {
   //       setAllImageUrls(signedUrls);
   //       setCurrentPage(0);
   //       const imagesToShow = signedUrls.slice(0, zoomedIn ? 1 : 2);
   //       setGlassboxImage(imagesToShow);
   //     });
   //   }
   //   console.log(glassboxImage, 'glassboxImage')
   // };
   // const getImageUrl = (imageurl) => {
   //   setGlassboxImage([]);
   //   AWS.config.update({ region: configData.LAMBDA_REGION });
   //   AWS.config.credentials = new AWS.Credentials({
   //     accessKeyId: configData.BASE_ACCESS_KEY_ID,
   //     secretAccessKey: configData.BASE_SECRET_ACCESS_KEY
   //   });
   //   let imgUrl, bucket, key, decodeImgUrl;
   //   imgUrl = new URL(imageurl);
   //   bucket = imgUrl.hostname.replace('.s3.amazonaws.com', '');
   //   decodeImgUrl = imgUrl.pathname.substr(imgUrl.pathname.indexOf('/') + 1);
   //   key = decodeURI(decodeImgUrl)
   //   const params = {
   //     Bucket: bucket,
   //     Key: key
   //   };
   //   let s3 = new AWS.S3();
   //   var url = s3.getSignedUrl('getObject', params);
   //   console.log(url)
   //   setGlassboxImage(prevImages => {
   //     const updated = [...prevImages, url];
   //     console.log(updated); // Correct place to log the updated array
   //     return updated;
   //   });
   //   console.log(glassboxImage)
   //   // return url;
   // }
   const [uniqueFRMNs, setUniqueFRMNs] = useState([]);
   const [clickedRuleForRoi, setClickedRuleForRoi] = useState();
   const getClickedField = (field, verbiage) => {
      setShowFullText(false);
      setStoreClikedRuleId(verbiage?.ERRSID);
      console.log(field, verbiage);
      setClickedConditionText(verbiage?.CDN);
      // const dynamicKey = Object.keys(field)[0];
      const dynamicKey = field && typeof field === 'object' ? Object.keys(field)[0] : null;
      setClickedRuleForRoi(field[dynamicKey])
      // const dataArray = field[dynamicKey];
      const dataArray = field?.[dynamicKey] ?? null;
      if (dataArray) {
         const frmns = dataArray.map(item => item.FRMN);
         const unique = [...new Set(frmns)];
         setUniqueFRMNs(unique);
      }
      setClickedFieldList(dataArray);
      if (Array.isArray(dataArray)) {
         // Build a list of image meta (IP and fcid)
         const imageMeta = dataArray
            .filter(item => item.IP)
            .map(item => ({
               url: 'https://' + configData.BUCKET_NAME + '.s3.amazonaws.com/' + item.IP,
               fcid: item.FCID
            }));
         // Get signed URLs only (no fcid passed to getImageUrl)
         Promise.all(imageMeta.map(meta => getImageUrl(meta.url)))
            .then(signedUrls => {
               // Merge fcid back in when setting glassboxImage
               const signedUrlsWithFcid = signedUrls.map((url, index) => ({
                  url,
                  fcid: imageMeta[index].fcid
               }));
               setAllImageUrls(signedUrlsWithFcid);
               setCurrentPage(0);
               const imagesToShow = signedUrlsWithFcid.slice(0, zoomedIn ? 1 : 2);
               setGlassboxImage(imagesToShow);
            });
      }
      console.log(glassboxImage, 'glassboxImage');
   };
   const getImageUrl = (imageurl) => {
      return new Promise((resolve) => {
         AWS.config.update({ region: configData.LAMBDA_REGION });
         AWS.config.credentials = new AWS.Credentials({
            accessKeyId: decrypt(getCookie('ak')),
            secretAccessKey: decrypt(getCookie('sk'))
         });
         const imgUrl = new URL(imageurl);
         const bucket = imgUrl.hostname.replace('.s3.amazonaws.com', '');
         const key = decodeURIComponent(imgUrl.pathname.substring(1));
         const params = {
            Bucket: bucket,
            Key: key,
         };
         const s3 = new AWS.S3({
            region: 'us-east-1',
         });
         const signedUrl = s3.getSignedUrl('getObject', params);
         resolve(signedUrl);
      });
   };
   const handleNext = () => {
      const IMAGES_PER_PAGE = zoomedIn ? 1 : 2;
      const nextPage = currentPage + 1;
      const startIdx = nextPage * IMAGES_PER_PAGE;
      const endIdx = startIdx + IMAGES_PER_PAGE;
      if (startIdx < allImageUrls.length) {
         setCurrentPage(nextPage);
         setGlassboxImage(allImageUrls.slice(startIdx, endIdx));
      }
   };
   const handlePrevious = () => {
      const IMAGES_PER_PAGE = zoomedIn ? 1 : 2;
      const prevPage = currentPage - 1;
      if (prevPage >= 0) {
         const startIdx = prevPage * IMAGES_PER_PAGE;
         const endIdx = startIdx + IMAGES_PER_PAGE;
         setCurrentPage(prevPage);
         setGlassboxImage(allImageUrls.slice(startIdx, endIdx));
      }
   };
   const handleZoomIn = () => {
      setZoomedIn(true);
      setCurrentPage(0);
      setGlassboxImage(allImageUrls.slice(0, 1));
   };
   const handleZoomOut = () => {
      setZoomedIn(false);
      setCurrentPage(0);
      setGlassboxImage(allImageUrls.slice(0, 2));
   };
   const [showextractionroiDivs, setShowextractionroiDivs] = useState(false)
   const imageRefs = useRef([]);
   const [focusedfieldroivalue, setFocusedfieldroivalue] = useState([])
   const [clickedfcid, setClickedfcid] = useState()
   const plotRoiForClickedField = (FieldValue) => {
      // const index = clickedRuleForRoi.findIndex(item => item.FCID === FieldValue.FCID);
      let clickedindex;
      if (Array.isArray(clickedRuleForRoi)) {
         clickedindex = clickedRuleForRoi.findIndex(item => item.FCID === FieldValue.FCID);
         console.log(`Index of FCID ${FieldValue.FCID}:`, clickedindex);
      }
      if (clickedindex !== -1 && clickedindex !== undefined) {
         const itemsPerPage = zoomedIn ? 1 : 2;
         const newPage = Math.floor(clickedindex / itemsPerPage);
         if (currentPage === 0 && clickedindex !== 0 && clickedindex !== 1) {
            if (newPage > currentPage) {
               handleNext();
               setCurrentPage(newPage);
            } else {
               handlePrevious();
               setCurrentPage(newPage);
            }
         } else {
            handlePrevious();
            setCurrentPage(newPage);
         }
      }
      setClickedfcid(FieldValue.FCID)
      console.log(JSON.parse(FieldValue.ROI));
      console.log(FieldValue)
      setShowextractionroiDivs(true)
      let currentimg = imageRefs.current[0]
      console.log(currentimg, 'currentimg');
      const newDivs = []
      const filtermnualjosnarray = JSON.parse(FieldValue.ROI);
      for (let i = 0; i < filtermnualjosnarray?.length; i++) {
         const x1 = filtermnualjosnarray[i].L * currentimg?.width;
         const x2 = filtermnualjosnarray[i].R * currentimg?.width;
         const y1 = filtermnualjosnarray[i].T * currentimg?.height;
         const y2 = filtermnualjosnarray[i].B * currentimg?.height;
         const left = 13 + x1 + 'px';
         const top = (currentimg?.offsetTop + y1) + 'px'
         const width = x2 - x1 + 'px'
         const height = y2 - y1 + 'px'
         console.log(left)
         console.log(top)
         console.log(width)
         console.log(height)
         const divs = (
            // className={`extractionroi${certifieditem.ImId}`}
            <div key={i} style={{ backgroundColor: 'rgba(255, 222, 2, .21)', border: '1px solid red', position: 'absolute', zIndex: '9999', top: top, width: width, left: left, height: height }}>
            </div>
         )
         newDivs.push(divs);
         console.log(newDivs, 'newDivs')
      }
      setFocusedfieldroivalue(newDivs)
   }
   const handleChangeStatus = (event) => {
      setStatus(event.target.value)
      filterDataByStatus(event.target.value, isSwitchOn);
   }
   const renderIcon = (status) => {
      switch (status) {
         case 'Waived':
            return <i style={{ color: 'red', fontSize: '12px' }} className="ri-close-line"></i>;
            break;
         case 'Override':
            return <i style={{ color: 'green', fontSize: '12px' }} className="ri-checkbox-circle-fill"></i>;
            break;
         case 'Cleared':
            return <i style={{ color: 'green', fontSize: '12px' }} className="ri-check-line"></i>;
            break;
         case 'Reviewed':
            return <i style={{ color: 'black', fontSize: '12px' }} className="ri-information-line"></i>;
            break;
         case 'Cleared Condition':
            return <TiInputChecked style={{ color: 'green', fontSize: '12px' }} />;
            break;
         case 'Manual Review':
            return <i className="ri-error-warning-line"></i>;
            break;
         case 'Fulfilled':
            return <i style={{ color: 'orange', fontSize: '12px' }} className="ri-check-double-line"></i>;
            break;
         default:
            return <i style={{ color: 'green', fontSize: '12px' }} className="ri-checkbox-circle-fill"></i>;
      }
   }
   const toggleText = () => setShowFullText(prev => !prev);
   let maxWidth;
   if (!showFullText) {
      if (window.innerWidth >= 1920) {
         maxWidth = '1025px';
      } else if (window.innerWidth >= 1680) {
         maxWidth = '987px';
      } else if (window.innerWidth >= 1600) {
         maxWidth = '855px';
      } else if (window.innerWidth >= 1366) {
         maxWidth = '808px';
      } else if (window.innerWidth >= 1280) {
         maxWidth = '680px';
      }
   } else {
      maxWidth = 'none';
   }


   useEffect(() => {
      const el = textRef.current;
      if (el) {
         // Temporarily force collapse to check overflow accurately
         el.style.whiteSpace = 'nowrap';
         const overflow = el.scrollWidth > el.clientWidth;
         setIsOverflowing(overflow);

         // Restore original setting
         el.style.whiteSpace = showFullText ? 'normal' : 'nowrap';
      }
   }, [clickedConditionText, maxWidth]);
   return (
      <>
         <Navbar collapseOnSelect expand="lg" className="bg-body-tertiary p-0 mb-1 glassbox-navbar" style={{ boxShadow: 'rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px', borderRadius: 'inherit' }}>
            <Container fluid>
               <Navbar.Brand><img src={dglogo} style={{ width: 'auto', height: '24px' }} /></Navbar.Brand>
               <Navbar.Toggle aria-controls="responsive-navbar-nav" />
               <Navbar.Collapse id="responsive-navbar-nav">
                  <Nav className="me-auto">
                  </Nav>
                  <Nav>
                     <Nav.Link className="fw-bold">
                        <svg xmlns="http://www.w3.org/2000/svg" style={{ width: '14px', height: '14px' }} fill="#000" viewBox="0 0 122.88 122.56">
                           <path d="M6.57,0H47.35a6.55,6.55,0,0,1,5.08,2.42,6.59,6.59,0,0,1,1.11,2,6.49,6.49,0,0,1,.39,2.2v40.6a6.63,6.63,0,0,1-4.14,6.1,6.47,6.47,0,0,1-2.44.48H6.57a6.4,6.4,0,0,1-2.41-.48,6.29,6.29,0,0,1-2.1-1.34A6.46,6.46,0,0,1,.55,49.76,6.27,6.27,0,0,1,0,47.17V6.57a6.43,6.43,0,0,1,.43-2.3,6.41,6.41,0,0,1,1.19-2L1.89,2A6.52,6.52,0,0,1,3.86.6,6.65,6.65,0,0,1,6.57,0ZM89.72,62.4a26.24,26.24,0,0,1,10.11,2l.07,0a25.4,25.4,0,0,1,4.54,2.44,25.66,25.66,0,0,1,4,3.27,26.08,26.08,0,0,1,3.3,4,26.79,26.79,0,0,1,2.44,4.58,25.29,25.29,0,0,1,1.5,5,26,26,0,0,1,.51,5.16,26.84,26.84,0,0,1-.27,3.82,27.37,27.37,0,0,1-.83,3.74,26,26,0,0,1-1.15,3.13,27.22,27.22,0,0,1-1.41,2.74l9.95,10.85a1.57,1.57,0,0,1-.09,2.23l-7.45,6.81a1.66,1.66,0,0,1-1.11.39,1.58,1.58,0,0,1-1.09-.51l-9.5-10.45a27.06,27.06,0,0,1-2.73,1.41,24.79,24.79,0,0,1-3.11,1.17h0a26.69,26.69,0,0,1-7.64,1.13,26.5,26.5,0,0,1-10.12-2l-.08,0A26.56,26.56,0,0,1,75,110.83a26.14,26.14,0,0,1-7.28-7.29,26.44,26.44,0,0,1-2.45-24.8l0-.08a27,27,0,0,1,2.44-4.53A26.42,26.42,0,0,1,75,66.86a26.15,26.15,0,0,1,4.58-2.45,26,26,0,0,1,10.12-2Zm14.51,11.94a21.13,21.13,0,0,0-3.12-2.56,20.83,20.83,0,0,0-3.55-1.9l-.06,0a19.41,19.41,0,0,0-3.8-1.14,20.74,20.74,0,0,0-4-.39,21.16,21.16,0,0,0-4,.39,20.46,20.46,0,0,0-3.83,1.16,20.83,20.83,0,0,0-3.55,1.9,20.55,20.55,0,0,0-3.11,2.56l-.07.06a21.26,21.26,0,0,0-2.52,3.09A20.7,20.7,0,0,0,70.75,81l0,.06a21,21,0,0,0-1.14,3.81,20.74,20.74,0,0,0-.38,4,20.38,20.38,0,0,0,.39,4,20.45,20.45,0,0,0,3,7.37,20.63,20.63,0,0,0,2.56,3.12l0,0a21.1,21.1,0,0,0,3.11,2.55,19.93,19.93,0,0,0,3.53,1.89A20.56,20.56,0,0,0,85.7,109a20.86,20.86,0,0,0,8,0,19.83,19.83,0,0,0,3.84-1.16,21.12,21.12,0,0,0,3.54-1.9,20.52,20.52,0,0,0,3.12-2.56l.06-.06a20.24,20.24,0,0,0,2.52-3.09,21.08,21.08,0,0,0,1.88-3.51l0-.07a20.31,20.31,0,0,0,1.13-3.8,20.74,20.74,0,0,0,.38-4,21,21,0,0,0-.38-4A21.33,21.33,0,0,0,108.69,81a20.74,20.74,0,0,0-1.9-3.54,21.25,21.25,0,0,0-2.56-3.12ZM6.57,62.07H47.35a6.52,6.52,0,0,1,2.82.64,6.67,6.67,0,0,1,3.37,3.73,6.49,6.49,0,0,1,.39,2.2v40.6a6.56,6.56,0,0,1-.53,2.57A6.66,6.66,0,0,1,51.9,114a6.72,6.72,0,0,1-4.55,1.85H6.57a6.6,6.6,0,0,1-2.41-.48A6.45,6.45,0,0,1,2.06,114a6.67,6.67,0,0,1-1.51-2.17A6.3,6.3,0,0,1,0,109.24V68.64a6.43,6.43,0,0,1,.43-2.3,6.57,6.57,0,0,1,1.19-2l.27-.27a6.67,6.67,0,0,1,2-1.38,6.49,6.49,0,0,1,2.71-.6Zm40.79,6.55H6.57l0,0,0,40.63c3.49,0,40.79,0,40.82,0,0-3.43,0-40.62,0-40.63ZM69.51,0h40.78a6.55,6.55,0,0,1,2.82.64,6.72,6.72,0,0,1,2.26,1.78,6.35,6.35,0,0,1,1.1,2,6.49,6.49,0,0,1,.39,2.2v40.6a6.56,6.56,0,0,1-.53,2.57,6.41,6.41,0,0,1-1.5,2.16,6.55,6.55,0,0,1-4.54,1.85H69.51a6.48,6.48,0,0,1-2.42-.48A6.39,6.39,0,0,1,65,51.93a6.68,6.68,0,0,1-2.06-4.76V6.57a6.66,6.66,0,0,1,1.63-4.31L64.82,2a6.58,6.58,0,0,1,4.69-2Zm40.78,6.55H69.51l0,0V47.2c3.5,0,40.79,0,40.83,0,0-3.43,0-40.61,0-40.63Zm-62.93,0H6.57l0,0,0,40.63c3.49,0,40.79,0,40.82,0,0-3.43,0-40.61,0-40.63Z" />
                        </svg>
                        Glassbox
                     </Nav.Link>
                  </Nav>
               </Navbar.Collapse>
            </Container>
         </Navbar>
         <div className="container-fluid glass-box">
            <Row>
               <Col sm={2} className="d-flex align-items-center ps-4">
                  <div className="row">
                     <div className="col-sm-6 p-0">
                        <Form.Select size="sm" aria-label="Default select example" onChange={(event) =>
                           handleChangeStatus(event)} value={status}>
                           <option value="All">All</option>
                           <option value="Open">Open</option>
                           <option value="Passed">Passed</option>
                        </Form.Select>
                     </div>
                     <div className="col-sm-4 pe-0 d-flex align-items-center">
                        <Form.Check
                           type="switch"
                           id="custom-switch"
                           checked={isSwitchOn}
                           onChange={handleSwitchChange}
                        />
                     </div>
                     <div className="col-sm-2 ps-0 d-flex align-items-center">
                        <div className="tooltipright"> <i class="ri-information-fill"></i> <span className="tooltiptext">Filter Rules With Images</span></div>
                     </div>
                  </div>
               </Col>
               <Col sm={8} className="mt-1 mb-2  glassbox">
                  <Row>
                     <Col sm={10} className="ps-0">
                        <Card className="mt-1 mb-0">
                           <Card.Body className="p-1">
                              {/* <p className="mb-0 text-truncate" style={{ fontSize: '11px' }}><b>Condition Description :</b> {clickedConditionText}</p> */}
                              <div className="d-flex" style={{ fontSize: '11px', alignItems: 'baseline' }}>
                                 <span
                                    ref={textRef}
                                    className="d-inline-block text-truncate"
                                    style={{
                                       overflow: 'hidden',
                                       textOverflow: 'ellipsis',
                                       whiteSpace: showFullText ? 'normal' : 'nowrap',
                                       maxWidth: showFullText ? '100%' : maxWidth,
                                       flexShrink: 1,
                                    }}
                                 >
                                    <b>Condition Description :</b> {clickedConditionText}
                                 </span>

                                 {isOverflowing && (
                                    <Button
                                       variant="link"
                                       size="sm"
                                       className="p-0 ms-1 flex-shrink-0"
                                       onClick={toggleText}
                                       aria-expanded={showFullText}
                                       style={{ fontSize: '11px', fontWeight: '400', textDecoration: 'underline' }}
                                    >
                                       {showFullText ? 'Less' : 'More'}
                                    </Button>
                                 )}
                              </div>
                           </Card.Body></Card>
                     </Col>
                     <Col sm={2} className="d-flex justify-content-center align-items-center pe-0">
                        <ListGroup horizontal className="my-1">
                           <ListGroup.Item>
                              <div class="btn-group dropstart">
                                 <button class="btn btn-link dropdown-toggle btn-sm" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                    <i class="ri-more-2-fill"></i>
                                 </button>
                                 <ul class="dropdown-menu">
                                    {
                                       uniqueFRMNs.map((frmname, index) => (
                                          <li key={index}><button class="dropdown-item" type="button">{frmname}</button></li>
                                       ))
                                    }
                                 </ul>
                              </div>
                           </ListGroup.Item>
                           <ListGroup.Item onClick={handlePrevious} className={currentPage === 0 ? "disabled-item" : ""}><i class="ri-skip-back-mini-fill icon-transition"></i></ListGroup.Item>
                           <ListGroup.Item onClick={handleNext} className={(currentPage + 1) * (zoomedIn ? 1 : 2) >= allImageUrls.length ? "disabled-item" : ""}><i class="ri-skip-forward-mini-fill icon-transition"></i></ListGroup.Item>
                           <ListGroup.Item onClick={handleZoomIn}><i class="ri-zoom-in-fill icon-transition"></i></ListGroup.Item>
                           <ListGroup.Item onClick={handleZoomOut}><i class="ri-zoom-out-fill icon-transition"></i></ListGroup.Item>
                        </ListGroup>
                     </Col>
                  </Row>
               </Col>
               <Col sm={2} className="mt-1 mb-2 d-flex justify-content-between">
                  <div className="d-flex justify-content-center align-items-center">
                     {hideLID && <h6 className="ps-3 pt-1">Loan Information Data</h6>}
                  </div>  <div className="d-flex justify-content-center align-items-center">
                     <button
                        className="btn btn-secondary btn-sm"
                        onClick={toggleCollapse}
                     >
                        {isCollapsed ? (
                           <i className="ri-arrow-right-s-line"></i>
                        ) : (
                           <i className="ri-arrow-left-s-line"></i>
                        )}
                     </button>
                  </div>
               </Col>
            </Row>
            <div className="row">
               <Col sm={2}>
                  <div className="leftpanel-scroll">
                     <div className="card">
                        <div className="card-body" style={{ padding: '6px' }}>
                           {groupedTabData && groupedTabData.map(item => (
                              <Card key={item.CID} style={{ marginBottom: '10px' }}>
                                 <Card.Header className="p-0" >
                                    <Button
                                       onClick={() => handleToggle(item.CID)}
                                       aria-controls={`collapse-text-${item.CID}`}
                                       aria-expanded={openCID === item.CID}
                                       variant="light"
                                       size="sm"
                                       className="w-100 fw-medium d-flex justify-content-between"
                                    >
                                       {item.CN}
                                       <i className="ri-arrow-down-s-line"></i>
                                    </Button>
                                 </Card.Header>
                                 <Collapse in={openCID === item.CID}>
                                    <Card.Body className="p-0" id={`collapse-text-${item.CID}`}>
                                       {/* <ListGroup>
                                          {item.Verbiage && item.Verbiage.map((verbiage, index) => (
                                             <div key={index}>
                                                {verbiage.FieldInfo && Object.keys(verbiage.FieldInfo).map((fieldKey, fieldIndex) => (
                                                   <div key={fieldIndex}>
                                                      <ListGroup.Item
                                                         key={fieldIndex}
                                                         as="li"
                                                         className={`d-flex justify-content-between align-items-start ${verbiage.ERRSID == storeClikedRuleId ? 'active' : ''}`}
                                                         onClick={() => getClickedField(verbiage.FieldInfo, verbiage)}
                                                      >
                                                         <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 122.56">
                                                            <path d="M6.57,0H47.35a6.55,6.55,0,0,1,5.08,2.42,6.59,6.59,0,0,1,1.11,2,6.49,6.49,0,0,1,.39,2.2v40.6a6.63,6.63,0,0,1-4.14,6.1,6.47,6.47,0,0,1-2.44.48H6.57a6.4,6.4,0,0,1-2.41-.48,6.29,6.29,0,0,1-2.1-1.34A6.46,6.46,0,0,1,.55,49.76,6.27,6.27,0,0,1,0,47.17V6.57a6.43,6.43,0,0,1,.43-2.3,6.41,6.41,0,0,1,1.19-2L1.89,2A6.52,6.52,0,0,1,3.86.6,6.65,6.65,0,0,1,6.57,0ZM89.72,62.4a26.24,26.24,0,0,1,10.11,2l.07,0a25.4,25.4,0,0,1,4.54,2.44,25.66,25.66,0,0,1,4,3.27,26.08,26.08,0,0,1,3.3,4,26.79,26.79,0,0,1,2.44,4.58,25.29,25.29,0,0,1,1.5,5,26,26,0,0,1,.51,5.16,26.84,26.84,0,0,1-.27,3.82,27.37,27.37,0,0,1-.83,3.74,26,26,0,0,1-1.15,3.13,27.22,27.22,0,0,1-1.41,2.74l9.95,10.85a1.57,1.57,0,0,1-.09,2.23l-7.45,6.81a1.66,1.66,0,0,1-1.11.39,1.58,1.58,0,0,1-1.09-.51l-9.5-10.45a27.06,27.06,0,0,1-2.73,1.41,24.79,24.79,0,0,1-3.11,1.17h0a26.69,26.69,0,0,1-7.64,1.13,26.5,26.5,0,0,1-10.12-2l-.08,0A26.56,26.56,0,0,1,75,110.83a26.14,26.14,0,0,1-7.28-7.29,26.44,26.44,0,0,1-2.45-24.8l0-.08a27,27,0,0,1,2.44-4.53A26.42,26.42,0,0,1,75,66.86a26.15,26.15,0,0,1,4.58-2.45,26,26,0,0,1,10.12-2Zm14.51,11.94a21.13,21.13,0,0,0-3.12-2.56,20.83,20.83,0,0,0-3.55-1.9l-.06,0a19.41,19.41,0,0,0-3.8-1.14,20.74,20.74,0,0,0-4-.39,21.16,21.16,0,0,0-4,.39,20.46,20.46,0,0,0-3.83,1.16,20.83,20.83,0,0,0-3.55,1.9,20.55,20.55,0,0,0-3.11,2.56l-.07.06a21.26,21.26,0,0,0-2.52,3.09A20.7,20.7,0,0,0,70.75,81l0,.06a21,21,0,0,0-1.14,3.81,20.74,20.74,0,0,0-.38,4,20.38,20.38,0,0,0,.39,4,20.45,20.45,0,0,0,3,7.37,20.63,20.63,0,0,0,2.56,3.12l0,0a21.1,21.1,0,0,0,3.11,2.55,19.93,19.93,0,0,0,3.53,1.89A20.56,20.56,0,0,0,85.7,109a20.86,20.86,0,0,0,8,0,19.83,19.83,0,0,0,3.84-1.16,21.12,21.12,0,0,0,3.54-1.9,20.52,20.52,0,0,0,3.12-2.56l.06-.06a20.24,20.24,0,0,0,2.52-3.09,21.08,21.08,0,0,0,1.88-3.51l0-.07a20.31,20.31,0,0,0,1.13-3.8,20.74,20.74,0,0,0,.38-4,21,21,0,0,0-.38-4A21.33,21.33,0,0,0,108.69,81a20.74,20.74,0,0,0-1.9-3.54,21.25,21.25,0,0,0-2.56-3.12ZM6.57,62.07H47.35a6.52,6.52,0,0,1,2.82.64,6.67,6.67,0,0,1,3.37,3.73,6.49,6.49,0,0,1,.39,2.2v40.6a6.56,6.56,0,0,1-.53,2.57A6.66,6.66,0,0,1,51.9,114a6.72,6.72,0,0,1-4.55,1.85H6.57a6.6,6.6,0,0,1-2.41-.48A6.45,6.45,0,0,1,2.06,114a6.67,6.67,0,0,1-1.51-2.17A6.3,6.3,0,0,1,0,109.24V68.64a6.43,6.43,0,0,1,.43-2.3,6.57,6.57,0,0,1,1.19-2l.27-.27a6.67,6.67,0,0,1,2-1.38,6.49,6.49,0,0,1,2.71-.6Zm40.79,6.55H6.57l0,0,0,40.63c3.49,0,40.79,0,40.82,0,0-3.43,0-40.62,0-40.63ZM69.51,0h40.78a6.55,6.55,0,0,1,2.82.64,6.72,6.72,0,0,1,2.26,1.78,6.35,6.35,0,0,1,1.1,2,6.49,6.49,0,0,1,.39,2.2v40.6a6.56,6.56,0,0,1-.53,2.57,6.41,6.41,0,0,1-1.5,2.16,6.55,6.55,0,0,1-4.54,1.85H69.51a6.48,6.48,0,0,1-2.42-.48A6.39,6.39,0,0,1,65,51.93a6.68,6.68,0,0,1-2.06-4.76V6.57a6.66,6.66,0,0,1,1.63-4.31L64.82,2a6.58,6.58,0,0,1,4.69-2Zm40.78,6.55H69.51l0,0V47.2c3.5,0,40.79,0,40.83,0,0-3.43,0-40.61,0-40.63Zm-62.93,0H6.57l0,0,0,40.63c3.49,0,40.79,0,40.82,0,0-3.43,0-40.61,0-40.63Z" />
                                                         </svg>
                                                         <div className="tooltiprulesource tooltip-container ms-2 me-auto">
                                                            <span className="tooltip-text">{fieldKey}</span>
                                                            <span className="tooltip-popup">
                                                               {verbiage.CDN}
                                                            </span>
                                                         </div>
                                                         {renderIcon(verbiage.RRSV)}
                                                      </ListGroup.Item>
                                                   </div>
                                                ))}
                                             </div>
                                          ))}
                                       </ListGroup> */}
                                       <ListGroup>
                                          {item.Verbiage?.map((verbiage, index) =>
                                             verbiage.FieldInfo &&
                                             Object.keys(verbiage.FieldInfo).map((fieldKey) => (
                                                <ListGroup.Item
                                                   key={`${index}-${fieldKey}`}
                                                   as="li"
                                                   className={`d-flex justify-content-between align-items-start ${verbiage.ERRSID === storeClikedRuleId ? 'active' : ''}`}
                                                   onClick={() => getClickedField(verbiage.FieldInfo, verbiage)}
                                                >
                                                   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122.88 122.56">
                                                      <path d="M6.57,0H47.35a6.55,6.55,0,0,1,5.08,2.42,6.59,6.59,0,0,1,1.11,2,6.49,6.49,0,0,1,.39,2.2v40.6a6.63,6.63,0,0,1-4.14,6.1,6.47,6.47,0,0,1-2.44.48H6.57a6.4,6.4,0,0,1-2.41-.48,6.29,6.29,0,0,1-2.1-1.34A6.46,6.46,0,0,1,.55,49.76,6.27,6.27,0,0,1,0,47.17V6.57a6.43,6.43,0,0,1,.43-2.3,6.41,6.41,0,0,1,1.19-2L1.89,2A6.52,6.52,0,0,1,3.86.6,6.65,6.65,0,0,1,6.57,0ZM89.72,62.4a26.24,26.24,0,0,1,10.11,2l.07,0a25.4,25.4,0,0,1,4.54,2.44,25.66,25.66,0,0,1,4,3.27,26.08,26.08,0,0,1,3.3,4,26.79,26.79,0,0,1,2.44,4.58,25.29,25.29,0,0,1,1.5,5,26,26,0,0,1,.51,5.16,26.84,26.84,0,0,1-.27,3.82,27.37,27.37,0,0,1-.83,3.74,26,26,0,0,1-1.15,3.13,27.22,27.22,0,0,1-1.41,2.74l9.95,10.85a1.57,1.57,0,0,1-.09,2.23l-7.45,6.81a1.66,1.66,0,0,1-1.11.39,1.58,1.58,0,0,1-1.09-.51l-9.5-10.45a27.06,27.06,0,0,1-2.73,1.41,24.79,24.79,0,0,1-3.11,1.17h0a26.69,26.69,0,0,1-7.64,1.13,26.5,26.5,0,0,1-10.12-2l-.08,0A26.56,26.56,0,0,1,75,110.83a26.14,26.14,0,0,1-7.28-7.29,26.44,26.44,0,0,1-2.45-24.8l0-.08a27,27,0,0,1,2.44-4.53A26.42,26.42,0,0,1,75,66.86a26.15,26.15,0,0,1,4.58-2.45,26,26,0,0,1,10.12-2Zm14.51,11.94a21.13,21.13,0,0,0-3.12-2.56,20.83,20.83,0,0,0-3.55-1.9l-.06,0a19.41,19.41,0,0,0-3.8-1.14,20.74,20.74,0,0,0-4-.39,21.16,21.16,0,0,0-4,.39,20.46,20.46,0,0,0-3.83,1.16,20.83,20.83,0,0,0-3.55,1.9,20.55,20.55,0,0,0-3.11,2.56l-.07.06a21.26,21.26,0,0,0-2.52,3.09A20.7,20.7,0,0,0,70.75,81l0,.06a21,21,0,0,0-1.14,3.81,20.74,20.74,0,0,0-.38,4,20.38,20.38,0,0,0,.39,4,20.45,20.45,0,0,0,3,7.37,20.63,20.63,0,0,0,2.56,3.12l0,0a21.1,21.1,0,0,0,3.11,2.55,19.93,19.93,0,0,0,3.53,1.89A20.56,20.56,0,0,0,85.7,109a20.86,20.86,0,0,0,8,0,19.83,19.83,0,0,0,3.84-1.16,21.12,21.12,0,0,0,3.54-1.9,20.52,20.52,0,0,0,3.12-2.56l.06-.06a20.24,20.24,0,0,0,2.52-3.09,21.08,21.08,0,0,0,1.88-3.51l0-.07a20.31,20.31,0,0,0,1.13-3.8,20.74,20.74,0,0,0,.38-4,21,21,0,0,0-.38-4A21.33,21.33,0,0,0,108.69,81a20.74,20.74,0,0,0-1.9-3.54,21.25,21.25,0,0,0-2.56-3.12ZM6.57,62.07H47.35a6.52,6.52,0,0,1,2.82.64,6.67,6.67,0,0,1,3.37,3.73,6.49,6.49,0,0,1,.39,2.2v40.6a6.56,6.56,0,0,1-.53,2.57A6.66,6.66,0,0,1,51.9,114a6.72,6.72,0,0,1-4.55,1.85H6.57a6.6,6.6,0,0,1-2.41-.48A6.45,6.45,0,0,1,2.06,114a6.67,6.67,0,0,1-1.51-2.17A6.3,6.3,0,0,1,0,109.24V68.64a6.43,6.43,0,0,1,.43-2.3,6.57,6.57,0,0,1,1.19-2l.27-.27a6.67,6.67,0,0,1,2-1.38,6.49,6.49,0,0,1,2.71-.6Zm40.79,6.55H6.57l0,0,0,40.63c3.49,0,40.79,0,40.82,0,0-3.43,0-40.62,0-40.63ZM69.51,0h40.78a6.55,6.55,0,0,1,2.82.64,6.72,6.72,0,0,1,2.26,1.78,6.35,6.35,0,0,1,1.1,2,6.49,6.49,0,0,1,.39,2.2v40.6a6.56,6.56,0,0,1-.53,2.57,6.41,6.41,0,0,1-1.5,2.16,6.55,6.55,0,0,1-4.54,1.85H69.51a6.48,6.48,0,0,1-2.42-.48A6.39,6.39,0,0,1,65,51.93a6.68,6.68,0,0,1-2.06-4.76V6.57a6.66,6.66,0,0,1,1.63-4.31L64.82,2a6.58,6.58,0,0,1,4.69-2Zm40.78,6.55H69.51l0,0V47.2c3.5,0,40.79,0,40.83,0,0-3.43,0-40.61,0-40.63Zm-62.93,0H6.57l0,0,0,40.63c3.49,0,40.79,0,40.82,0,0-3.43,0-40.61,0-40.63Z" />
                                                   </svg>
                                                   <div className="tooltiprulesource tooltip-container ms-2 me-auto">
                                                      <span className="tooltip-text">{fieldKey}</span>
                                                      <span className="tooltip-popup">{verbiage.CDN}</span>
                                                   </div>
                                                   {renderIcon(verbiage.RRSV)}
                                                </ListGroup.Item>
                                             ))
                                          )}
                                       </ListGroup>

                                    </Card.Body>
                                 </Collapse>
                              </Card>
                           ))}
                        </div>
                     </div>
                  </div>
               </Col>
               <div className={`col-sm-${isCollapsed ? 10 : 8} glassbox-scroll transition-all`}>
                  <Row>
                     {glassboxImage.length > 0 ? (
                        glassboxImage.map((imgItem, index) => (
                           <Col sm={zoomedIn ? 12 : 6} className="" style={{ position: "relative" }} key={index}>
                              <img
                                 src={imgItem.url}
                                 ref={(el) => (imageRefs.current[index] = el)}
                                 className="w-100 img-shadow"
                                 alt={`image-${index}`}
                              />
                              {showextractionroiDivs && clickedfcid === imgItem.fcid &&
                                 focusedfieldroivalue.map((div, idx) => (
                                    <Fragment key={idx}>{div}</Fragment>
                                 ))}
                           </Col>
                        ))
                     ) : (
                        <Col sm={12}>
                           <div style={{ textAlign: 'center' }}>No Image For This Rule</div>
                        </Col>
                     )}
                  </Row>
               </div>
               {!isCollapsed && (
                  <div className="col-sm-2 glassbox-scroll">
                     <Card>
                        <Card.Body className="glassbox-formfields">
                           <h6>Extracted Fields</h6>
                           <Form>
                              {clickedFieldList &&
                                 clickedFieldList.filter(fielddata => fielddata.FRMN !== "IMP").length > 0 ? (
                                 clickedFieldList
                                    .filter(fielddata => fielddata.FRMN !== "IMP")
                                    .map((fielddata, index) => (
                                       <div key={index}>
                                          <Form.Group>
                                             <Form.Label>{fielddata.FLDN}</Form.Label>
                                             <Form.Control
                                                type="text"
                                                size="sm"
                                                value={fielddata.CRTFLDVAL}
                                                onClick={() =>
                                                   plotRoiForClickedField(fielddata)}
                                                readOnly
                                                style={{ backgroundColor: 'gainsboro' }}
                                             />
                                          </Form.Group>
                                       </div>
                                    ))
                              ) : (
                                 <p style={{ textAlign: 'center', fontSize: "12px" }}>No Data</p>
                              )}
                           </Form>
                           <hr />
                           <h6>Loan Import Data</h6>
                           <Form>
                              {clickedFieldList &&
                                 clickedFieldList.filter(fielddata => fielddata.FRMN === "IMP").length > 0 ? (
                                 clickedFieldList
                                    .filter(fielddata => fielddata.FRMN === "IMP")
                                    .map((fielddata, index) => (
                                       <div key={index}>
                                          <Form.Group>
                                             <Form.Label>{fielddata.FLDN}</Form.Label>
                                             <Form.Control
                                                type="text"
                                                size="sm"
                                                value={fielddata.CRTFLDVAL}
                                                onClick={() =>
                                                   plotRoiForClickedField(fielddata)}
                                                readOnly
                                                style={{ backgroundColor: 'gainsboro' }}
                                             />
                                          </Form.Group>
                                       </div>
                                    ))
                              ) : (
                                 <p style={{ textAlign: 'center', fontSize: "12px" }}>No Data</p>
                              )}
                           </Form>
                        </Card.Body>
                     </Card>
                  </div>
               )}
            </div>
         </div>
      </>
   );
};
export default GlassBox;